import { useEffect, useRef, useState } from 'react';

const useRouteLoading = () => {
  const [loading, setLoading] = useState(false); // Start with false to match SSR
  const initialLoad = useRef(true);

  useEffect(() => {
    if (initialLoad.current) {
      try {
        // Initial load: show loading spinner
        setLoading(true);
        const timer = setTimeout(() => {
          setLoading(false);
          initialLoad.current = false;
        }, 500);

        return () => clearTimeout(timer);
      } catch (error) {
        console.error('Error in useRouteLoading:', error);
        setLoading(false);
        initialLoad.current = false;
      }
    }
  }, []); // Empty dependency array: only run on mount

  return loading;
};

export default useRouteLoading;
